import { isInTriageMode } from 'pages/alerts/utils';

import { eventDefinitions } from './index';

import type { EventData } from '../types';

/**
 * Determines the view based on eventData and triage mode.
 * If eventData contains a view, it uses that.
 * Otherwise, it returns 'triage' if in triage mode, or 'list' by default.
 */
export const getIntelView = (eventData: EventData = {}): string => {
  if (eventData?.view) {
    return eventData.view;
  }
  return isInTriageMode() ? 'triage' : 'list';
};

/**
 * Checks if a Snowplow event is defined in the event definitions.
 * Used to conditionally render UI elements that depend on analytics events.
 */
export const isSnowplowEventDefined = (eventName: string): boolean => {
  return eventName in eventDefinitions;
};
